import { NgClass } from '@angular/common';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { Subscription } from 'rxjs';
import { HeaderComponent } from './header/header.component';
import { AppRoutingModule } from 'src/app/app-routing.module';

@Component({
  imports: [AppRoutingModule, HeaderComponent, NgClass],
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css'],
})
export class LayoutComponent implements OnInit, OnDestroy {
  private loadingBar = inject(LoadingBarService);
  private router = inject(Router);

  public isSeatSelectionRoute = false;

  private subscriptions: Subscription[] = [];

  constructor() {
    this.loadingBar.useRef();
  }

  ngOnInit(): void {
    const routerEventSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.isSeatSelectionRoute = event.url.includes('seat-selection');
      }
    });
    this.subscriptions.push(routerEventSubscription);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }
}
